import React, { useState } from "react";
import { RupeesIcon } from "../../components/HeaderSidebarIcons";
import Header from "../Layouts/Header";
import { Button } from "@heroui/react";

const stakeNum = [5, 10, 50, 100, 200, 500, 1000, 5000];

export default function Design() {
  const [selectedStake, setSelectedStake] = useState(null);
  return (
    <div>

      <div className="max-w-screen-md mx-auto px-4 py-6">
        <div className="bg-white shadow-shadow_color shadow-md rounded-md p-4 border border-gray-300">
          <form method="POST" className="space-y-4">
            {/* Date and Game Select */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <div className="border p-2 rounded-md text-center font-semibold text-sm">
                  08/07/2025
                </div>
              </div>
              <div>
                <select
                  name="game_id"
                  className="w-full border p-2 rounded-md text-sm"
                >
                  <option value="19">MILAN NIGHT OPEN</option>
                  <option value="20">MILAN NIGHT CLOSE</option>
                </select>
              </div>
            </div>

            <hr className="border-gray-300" />

            {/* Select Amount */}
            <h3 className="text-lg font-semibold">Select Amount</h3>
            <div className="grid grid-cols-4 gap-3 text-center">
              {[5, 10, 50, 100, 200, 500, 1000, 5000].map((amt) => (
                <button
                  key={amt}
                  type="button"
                  className="border p-2 rounded-md hover:bg-blue-100 font-medium text-sm"
                  data-amount={amt}
                >
                  ₹ {amt}
                </button>
              ))}
            </div>

            <hr className="border-gray-300" />

            {/* Select Digits */}
            <h3 className="text-lg font-semibold">Select Digits</h3>
            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-3">
              {[...Array(10).keys()].map((digit) => (
                <div key={digit} className="flex flex-col items-center">
                  <label className="font-medium text-sm">{digit}</label>
                  <input
                    type="text"
                    name={`single${digit}`}
                    id={`single${digit}`}
                    readOnly
                    className="w-16 border rounded-md p-1 text-center text-sm"
                  />
                </div>
              ))}
            </div>

            {/* Hidden Inputs */}
            <input type="hidden" name="total_point" id="total_point" />
            <input type="hidden" name="selected_amount" id="selected_amount" />
            <input type="hidden" name="gid" value="19" />
            <input type="hidden" name="pgid" value="13" />
            <input type="hidden" name="dgame" value="open" />

            {/* Total Points */}
            <div className="text-center">
              <p className="text-sm font-medium">
                Total Points: <span id="total_point2">0</span>
              </p>
            </div>

            {/* Buttons */}
            <div className="grid grid-cols-2 gap-4">
              <button
                type="reset"
                className="w-full py-2 border border-gray-400 rounded-md bg-gray-100 hover:bg-gray-200 text-sm font-medium"
   
              >
                Reset
              </button>
              <button
                type="submit"
                name="single_submit"
                className="w-full py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm font-medium"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    // <div className="border border-m_gray rounded-lg p-4 mt-1 w-full">
    //   <h1 className="text-center font-medium mb-2">Select Amount</h1>
    //   <div className="flex flex-col md:flex-row justify-between items-center mb-4">
    //     <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 w-full">
    //       {stakeNum.map((number, index) => (
    //         <Button
    //           key={index}
    //           size="md"
    //           onClick={() => setSelectedStake(number)}
    //           className={`h-10 min-w-[80px] sm:min-w-[100px] w-full border border-gray-300
    //             ${
    //               selectedStake === number
    //                 ? "bg-gray-400 text-white"
    //                 : "bg-m_bg2"
    //             }
    //             hover:bg-gray-400 hover:text-white transition-colors`}
    //           variant="flat"
    //           color="default"
    //           style={{
    //             borderRadius: "10px",
    //             textAlign: "center",
    //             cursor: "pointer",
    //             display: "flex",
    //             flexDirection: "column",
    //             justifyContent: "center",
    //           }}
    //         >
    //           <div className="flex flex-col items-center">
    //             <div className="flex">
    //               <span className="text-sm text-black-50">
    //                 <RupeesIcon />
    //               </span>
    //               <span>{number}</span>
    //             </div>
    //           </div>
    //         </Button>
    //       ))}
    //     </div>
    //   </div>
    // </div>
  );
}
